import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { isGuestAlreadyInArray } from '@utils/helpers';
import { MappedGuest } from '../../types';

export const useGuestDetailsUpdate = (
  availableGuests: MappedGuest[],
  setAvailableGuests: (guests: MappedGuest[]) => void
) => {
  const { watch } = useFormContext();

  return useCallback(() => {
    const guests = watch('guests') || [];
    const updatedAvailableGuests = availableGuests;

    guests.forEach((guest) => {
      if (
        guest?.guestDetails?.firstName &&
        guest?.guestDetails?.lastName &&
        !isGuestAlreadyInArray(updatedAvailableGuests, guest.guestDetails)
      ) {
        updatedAvailableGuests.push(guest.guestDetails);
      }
    });

    setAvailableGuests(updatedAvailableGuests);
  }, [availableGuests, setAvailableGuests, watch]);
};
